import { render } from "./DialogNewDatabankIntoDitribution.vue?vue&type=template&id=0e165a36"
import script from "./DialogNewDatabankIntoDitribution.vue?vue&type=script&lang=js"
export * from "./DialogNewDatabankIntoDitribution.vue?vue&type=script&lang=js"

import "./DialogNewDatabankIntoDitribution.vue?vue&type=style&index=0&id=0e165a36&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__